import ProductCards from '@common/components/ProductCards';
import Product, { PRODUCT_REFERRED_FROM } from '@common/models/Product';
import { RecentlyViewedTime } from '@common/store/recentlyViewed/slice';
import { isMobile } from '@common/utils';
import LChevron1 from '@images/LChevron1.svg';
import classnames from 'classnames';
import React, { useState } from 'react';

interface RecentlyViewedProps {
  products: Array<Product> | Record<number, Product & RecentlyViewedTime>;
  referredFrom?: PRODUCT_REFERRED_FROM;
  title?: string;
  ignoreProducts?: Set<number>;
  className?: string;
}

const RecentlyViewed: React.FunctionComponent<RecentlyViewedProps> = ({
  products,
  ignoreProducts = new Set(),
  title = 'Recently Viewed',
  referredFrom,
  className,
}) => {
  const filteredProducts = (Array.isArray(products) ? [...products] : Object.values(products))
    .reverse()
    .filter((product) => !ignoreProducts.has(product.id));
  if (!filteredProducts.length) {
    return null;
  }
  return <div className={`${className}`}>{RecentlyViewedBar(filteredProducts, title, referredFrom)}</div>;
};

const RecentlyViewedBar = (filteredProducts, title, referredFrom) => {
  const [LeftArrow, SetLeftArrow] = useState(false);
  const [RightArrow, SetRightArrow] = useState(true);
  return (
    <>
      <div
        className="text-heading text-center text-24 md:text-32 mb-48 font-semibold md:leading-loose"
        font-customisation="section-heading"
        color-customisation="page-heading"
      >
        {title}
      </div>
      <div className="relative">
        <div
          className="flex flex-col md:flex-row flex-no-wrap overflow-x-auto "
          id={`recently-viewed`}
          onScroll={() => {
            const ele = document.getElementById(`recently-viewed`);
            let val = 0;
            if (isMobile()) val = 100;
            else val = 200;
            if (ele.scrollLeft > val) SetLeftArrow(true);
            else SetLeftArrow(false);
            ele.scrollWidth - ele.scrollLeft === ele.clientWidth ? SetRightArrow(false) : SetRightArrow(true);
          }}
        >
          {filteredProducts.map((product) => (
            <div key={product?.id} className="ml-20 md:ml-30 md:first:ml-0 justify-between items-center">
              <ProductCards
                key={product.id}
                product={product}
                referredFrom={referredFrom}
                mainDivClassNames=""
                imageDivClassNames=""
                discountPercentClassNames={'hidden'}
                titleClassName={`font-medium md:w-full text-productCard-title md:leading-30 leading-24 line-clamp-2 mb-8 break-word-only`}
                priceClassName={
                  'rupeeSymbol font-medium leading-22 md:leading-20 text-productCard-finalPrice text-16 mr-10'
                }
                discountPriceClassName={
                  'line-through leading-22 md:leading-20 text-14 font-normal text-productCard-mrp'
                }
                includeTaxClassName={'hidden'}
                infoMainDivClassName="pt-16 pb-24 px-16 flex flex-col items-center text-center"
                dimensionH={'md:h-417 h-306'}
                dimensionW={'md:w-278 w-204'}
              />
            </div>
          ))}
        </div>
        {filteredProducts?.length > 3 && (
          <div className="hidden md:block">
            {LeftArrow && (
              <div className="absolute left-0 md:left-m32 h-32 w-32 top-1/2">
                <button
                  className={classnames('', {
                    'opcaity-50': !LeftArrow,
                  })}
                  onClick={() => {
                    document.getElementById(`recently-viewed`).scrollBy({
                      top: 0,
                      left: isMobile() ? -300 : -1250,
                      behavior: 'smooth',
                    });
                  }}
                >
                  <img src={LChevron1} className="fill-current" />
                </button>
              </div>
            )}
            {RightArrow && (
              <div className="absolute right-0 md:right-m32 h-32 w-32 top-1/2">
                <button
                  className={classnames('', {
                    'opacity-50': !RightArrow,
                  })}
                  onClick={() => {
                    document.getElementById(`recently-viewed`).scrollBy({
                      top: 0,
                      left: isMobile() ? +300 : +1250,
                      behavior: 'smooth',
                    });
                  }}
                >
                  <img src={LChevron1} className=" fill-current transform -rotate-180" />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};
export default RecentlyViewed;
